export enum PaymentGateway {
  REDSYS,
  PAYPAL,
  BIZUM,
  PHONEANDSELL
}
